import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsSoftwareNotificationsIssueLogsRoute: InvariantJiraRoute = {
	name: 'classic-software-notifications-issue-logs',
	path: '/jira/software/c/projects/:projectKey/settings/notifications/issue-logs',
	query: ['projectId'],
};
